
//Représente les paramètres de mise à jour de la corbeille GED de destination des factures d’achat (SU #120249)
//  La liste porte les lignes cochées de la grille, à défaut la ligne au focus. Elle ne peut pas
//  être vide : le menu est grisé sans sélection.
//  La corbeille cible s’applique à toute la sélection ; nulle, elle retire la corbeille de destination.
export class AeFMettreAJourCorbeilleGedFacturesAchatParametres
{
  //Création
  constructor ()
  {
    this.identifiantsFactures = [];
    this.identifiantCorbeilleGed = null;
  }

  //Identifiants des factures sélectionnées dans la grille
  public identifiantsFactures: string[];

  //Identifiant de la corbeille GED de destination, nul pour retirer la corbeille
  public identifiantCorbeilleGed: string | null;
}

//Représente une facture écartée par la mise à jour de la corbeille GED, et son motif (SU #120249)
export class AeFFactureAchatEcarteeCorbeilleGed
{
  //Numéro de la facture, tel qu’il apparaît dans la grille des achats
  public numero!: string;

  //Motif pour lequel la facture a été écartée, rédigé par le serveur
  public motif!: string;
}

//Représente le résultat de la mise à jour de la corbeille GED des factures d’achat (SU #120249)
export class AeFMettreAJourCorbeilleGedFacturesAchatResultat
{
  //Création
  constructor ()
  {
    this.nombreFacturesModifiees = 0;
    this.nombreFacturesInchangees = 0;
    this.facturesEcartees = [];
  }

  //Nombre de factures dont la corbeille de destination a été modifiée
  public nombreFacturesModifiees: number;

  //Nombre de factures déjà dans l’état demandé
  public nombreFacturesInchangees: number;

  //Factures que le traitement n’a pas pu traiter, et le motif de chacune
  public facturesEcartees: AeFFactureAchatEcarteeCorbeilleGed[];
}
